import React, { useEffect, useState } from 'react';
import {
  Wrapper,
  Col1,
  Title,
  Card,
  FormLayout,
  TopRow,
  MainRow,
  FieldHead,
  Field,
  CustomLabel,
  Required,
  Actions,
  BackButton,
  SaveButton,
  LoadingWrapper,
  PreviewWrap,
  ClearImageButton,
  PreviewImage,
  PreviewPlaceholder,
  DescriptionBox,
  FileInput,
  Hint
} from './style';
import { useDispatch } from 'react-redux';
import { Input, Loading } from '../../../components/common';
import { SelectInput } from 'vqp-common';
import {
  fetchDestaqueId,
  postDestaque,
  updateDestaque
} from '../../../redux/actions/destaques';
import { Dialog, DialogContent, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router-dom';
import { getStoreInfo } from '../../../utils/storeInfo';
import {
  DESCRICAO_MAX_LENGTH,
  getDestaqueImageTarget,
  TIPO_MODULO_HOME,
  TIPO_PLATAFORMA_OPTIONS
} from '../constants';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const findOptionIndex = (options, value) => {
  const index = options.findIndex((item) => item.value === value);
  return index >= 0 ? index : 0;
};

const selectedValue = (options, selectedIndex) => {
  const option = options[selectedIndex];
  return option && option.value !== '' ? option.value : null;
};

const LayoutCreatePage = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const storeInfo = getStoreInfo();
  const aplicativoId = storeInfo?.app?.id;

  const [loading, setLoading] = useState(false);
  const [destaqueId, setDestaqueId] = useState(null);
  const [descricao, setDescricao] = useState('');
  const [ordem, setOrdem] = useState('0');
  const [tipoPlataforma, setTipoPlataforma] = useState(0);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [openSuccess, setOpenSuccess] = useState(false);

  useEffect(() => {
    const locationState = props.location.state || {};
    setDestaqueId(locationState.id || null);
    if (locationState.imagemUrl) {
      setImagePreview(locationState.imagemUrl);
    }
  }, [props.location.state]);

  useEffect(() => {
    async function loadDestaque() {
      try {
        setLoading(true);
        const response = await dispatch(fetchDestaqueId(destaqueId));
        if (response.success && response.data) {
          const data = response.data;
          setDescricao(data.descricao || '');
          setOrdem(data.ordem != null ? String(data.ordem) : '0');
          setTipoPlataforma(findOptionIndex(TIPO_PLATAFORMA_OPTIONS, data.tipoPlataformaId));
          if (data.imagemUrl) {
            setImagePreview(data.imagemUrl);
          }
        }
      } catch (e) {
        console.error('Erro ao buscar destaque por id', e);
      } finally {
        setLoading(false);
      }
    }

    if (destaqueId) {
      loadDestaque();
    }
  }, [destaqueId, dispatch]);

  const tipoPlataformaId = selectedValue(TIPO_PLATAFORMA_OPTIONS, tipoPlataforma);
  const imageTarget = getDestaqueImageTarget(tipoPlataformaId);

  const handleChangeImage = ({ target }) => {
    const [file] = target.files || [];
    if (!file) return;

    setImage(file);
    const reader = new FileReader();
    reader.onload = (e) => setImagePreview(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleTipoPlataformaChange = (index) => {
    setTipoPlataforma(index);
  };

  const handleClearImage = () => {
    setImage(null);
    setImagePreview(null);
    const fileInput = document.getElementById('image');
    if (fileInput) fileInput.value = '';
  };

  const handleDescricaoChange = (value) => {
    setDescricao(String(value).slice(0, DESCRICAO_MAX_LENGTH));
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const showError = (message) => {
    setSnackbarSeverity('error');
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  const buildPayload = () => ({
    descricao,
    url: null,
    deepLinking: false,
    ordem,
    tipoPlataformaId: selectedValue(TIPO_PLATAFORMA_OPTIONS, tipoPlataforma),
    tipoModuloId: TIPO_MODULO_HOME,
    tipoAcaoDestaqueId: null,
    estabelecimentoId: null,
    aplicativoId,
    image
  });

  const handleSubmit = async () => {
    if (!image && !imagePreview) {
      showError('Upload de imagem é obrigatório.');
      return;
    }
    if (ordem === '' || ordem == null) {
      showError('Ordem é obrigatória.');
      return;
    }
    if (selectedValue(TIPO_PLATAFORMA_OPTIONS, tipoPlataforma) == null) {
      showError('Selecione onde o destaque deve ser exibido.');
      return;
    }
    if (!descricao) {
      showError('Descrição é obrigatória.');
      return;
    }

    setLoading(true);
    const payload = buildPayload();
    const response = destaqueId
      ? await dispatch(updateDestaque(destaqueId, payload))
      : await dispatch(postDestaque(payload));

    setLoading(false);

    if (response.success) {
      setOpenSuccess(true);
    } else {
      showError(response.error || 'Erro ao salvar destaque.');
    }
  };

  const handleBack = () => {
    history.push('/layout');
  };

  const handleSuccessClose = () => {
    setOpenSuccess(false);
    history.push('/layout');
  };

  const caracteresRestantes = DESCRICAO_MAX_LENGTH - (descricao ? descricao.length : 0);

  return (
    <Wrapper>
      <Col1>
        <Title>{destaqueId ? 'Editar Destaque' : 'Cadastrar Destaque'}</Title>
        {loading && (
          <LoadingWrapper>
            <Loading />
          </LoadingWrapper>
        )}
        <Card>
          <FormLayout>
            <TopRow>
              <Field>
                <CustomLabel>
                  Exibir em <Required>*</Required>
                </CustomLabel>
                <SelectInput
                  options={TIPO_PLATAFORMA_OPTIONS}
                  selected={tipoPlataforma}
                  onSelect={handleTipoPlataformaChange}
                />
              </Field>

              <Field>
                <CustomLabel>
                  Ordem <Required>*</Required>
                </CustomLabel>
                <Input id="ordem" name="ordem" type="number" value={ordem} onChange={setOrdem} />
              </Field>
            </TopRow>

            <MainRow>
              <FieldHead>
                <CustomLabel>
                  Upload de Imagem <Required>*</Required>
                </CustomLabel>
                <FileInput id="image" name="image" type="file" accept="image/*" onChange={handleChangeImage} />
                <Hint style={{ marginBottom: '6px' }}>
                  {tipoPlataformaId == null
                    ? 'Selecione onde o destaque será exibido para ver o tamanho recomendado.'
                    : `Tamanho recomendado: ${imageTarget.label}`}
                </Hint>
              </FieldHead>

              <FieldHead style={{ display: 'flex', justifyContent: 'end' }}>
                <CustomLabel>
                  Descrição (Caracteres restantes: {caracteresRestantes})
                  <Required>*</Required>
                </CustomLabel>
              </FieldHead>

              {imagePreview ? (
                <PreviewWrap>
                  <ClearImageButton type="button" onClick={handleClearImage} title="Remover imagem">
                    ×
                  </ClearImageButton>
                  <PreviewImage
                    src={imagePreview}
                    alt="Preview do destaque"
                    referrerPolicy="no-referrer"
                  />
                </PreviewWrap>
              ) : (
                <PreviewPlaceholder>
                  A prévia da imagem aparecerá aqui
                </PreviewPlaceholder>
              )}

              <DescriptionBox>
                <Input
                  id="descricao"
                  name="descricao"
                  multi
                  rows={8}
                  value={descricao}
                  onChange={handleDescricaoChange}
                  maxLength={DESCRICAO_MAX_LENGTH}
                />
              </DescriptionBox>
            </MainRow>
          </FormLayout>

          <Actions>
            <BackButton className="default" onClick={handleBack}>
              Voltar
            </BackButton>
            <SaveButton className="primary" onClick={handleSubmit} disabled={loading}>
              Salvar
            </SaveButton>
          </Actions>
        </Card>

        <Dialog open={openSuccess} onClose={handleSuccessClose} fullWidth maxWidth="xs">
          <DialogContent>
            <p style={{ textAlign: 'center' }}>Destaque salvo com sucesso!</p>
            <Actions className="center">
              <SaveButton className="primary" onClick={handleSuccessClose}>
                Voltar para listagem
              </SaveButton>
            </Actions>
          </DialogContent>
        </Dialog>

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Col1>
    </Wrapper>
  );
};

export default LayoutCreatePage;
